<template>
  <div class="notice">
    <div>
      <el-form
        :inline="true"
        :model="formSearch"
        ref="formSearch"
        class="demo-form-inline"
      >
        <el-form-item class="date">
          <el-date-picker
            v-model="formSearch.formdate"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            style="width: 270px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <product-select
            :value.sync="formSearch.afid"
            placeholder="请选择产品"
            :isDefault="true"
            popper-class="BI-select BI-select-product"
          >
          </product-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="formSearch.warnType" placeholder="预警类型">
            <el-option
              v-for="item in warnTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleClickSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { changeshortcutclass, clearallshortcutclass } from "@/utils/tool";
import { warnTypeList } from "../config";
export default {
  data() {
    return {
      warnTypeList,
      formSearch: {
        formdate: [
          new Date(new Date().getTime() - 3600 * 1000 * 24 * 6),
          new Date(),
        ],
        afid: null,
        warnType: 1,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "当天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("当天", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一周", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一个月", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近2个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近2个月", picker.$el);
              }, 0);
            },
          },
        ],
        onPick: function ({ maxDate, minDate }) {
          clearallshortcutclass(this.$el);
          console.log(maxDate, minDate);
        },
        disabledDate: function (date) {
          if (new Date().getTime() - date.getTime() > 0) {
            return false;
          }
          return true;
        },
        // disabledDate: function(time) {
        //   return time.getTime() > Date.now();
        // }
      },
    };
  },

  computed: {},

  watch: {},

  mounted() {
    const timer = setInterval(() => {
      if (this.formSearch.afid) {
        clearInterval(timer);
        this.$emit("handleSearch", this.formSearch);
      }
    }, 200);
  },

  methods: {
    handleClickSearch() {
      this.$emit("handleSearch", this.formSearch);
    },
  },
};
</script>

<style lang="less" scoped>
.notice {
  .date {
    // margin-bottom: 10px;
    /deep/ .el-range-separator {
      line-height: 25px;
    }
    /deep/ .el-range__icon {
      line-height: 25px;
    }
  }
}
</style>
